import React from 'react';
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CTAButton({
  children,
  href = '#oferta',
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const sizes = {
    md: 'px-6 py-4 text-base',
    lg: 'px-7 py-5 text-base sm:text-lg'
  };
  return <a href={href} className={`inline-flex w-full max-w-md items-center justify-center gap-2 rounded-full bg-frambuesa text-center font-sans font-bold uppercase tracking-wide text-white shadow-suave transition-all duration-200 hover:-translate-y-0.5 hover:bg-frambuesa-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-frambuesa-dark active:translate-y-0 ${sizes[size]} ${className}`} data-id="element-223" data-mp="1l8r1b36hc112">
      {children}
    </a>;
}